import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/auth-slice";
import wishlistReducer from "./slices/wishlist-slice";

const store = configureStore({
  reducer: {
    authReducer,
    wishlist: wishlistReducer, 
  },
});

export default store;